module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title7"
    }
  }), _c('div', {
    staticClass: "title-chapter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("G")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gabars:")]), _vm._v(" The popular name for the Zoroastrians living in Persia. (Also called "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ghebers")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Galvanic mirror:")]), _vm._v(" A concave copper disk and a convex zinc disk joined together and magnetized; used for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("scrying")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gameway ceremonials:")]), _vm._v(" Magic hunting rites of the Navajo Indians.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gamut:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Notes of the gamut.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gandharvas:")]), _vm._v(" In Vedic lore, the divine musicians in Indra’s heaven; they possess mysterious power over women.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ganesha:")]), _vm._v(" The elephant-headed divinity of Shivaism. Ganesha, son of Shiva, is the god of good luck, prosperity and wisdom, and the remover of obstacles.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ganga:")]), _vm._v(" Sudanese magic.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Garbha:")]), _vm._v(" Sanskrit for seed. The creative power that lies at the bottom of the world, hypostatized in or symbolized by the germ or seed. In cosmologico-metaphysical conception it is allied to such "), _c('em', {
    staticClass: "i"
  }, [_vm._v("termini technici")]), _vm._v(" as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("hiranyagarbha")]), _vm._v(" (golden germ), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("bija")]), _vm._v(" (seed), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("retas")]), _vm._v(" (semen), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("yoni")]), _vm._v(" (womb), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("anda")]), _vm._v(" (egg, world-egg), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("jan")]), _vm._v(" (to give birth to), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("srj")]), _vm._v(" (to pour out), etc., descriptive of psycho-cosmogony from the earliest days of Indian philosophy.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gastromancy:")]), _vm._v(" Divination by gazing into a vessel filled with water, or divination by ventriloquist sounds.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gates of reason:")]), _vm._v(" According to a Hebrew mystic legend, there are fifty gates to reason, of which forty-nine were disclosed to Moses.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gathas:")]), _vm._v(" The oldest part of the Avesta, containing the most authentic version of the teachings of Zoroaster.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gehenna:")]), _vm._v(" The word is derived from the Hebrew "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Ge Hinnom,")]), _vm._v(" the Valley of Hinnom, near Jerusalem, where the ancient Israelites sacrificed children to the god Moloch; in later times, the valley was regarded as a place of refuse, where fires were kept continually burning to prevent pestilence. The name "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Gehenna")]), _vm._v(" was adopted for the “bottomless pit” of eternal fire where the wicked are thrust after death and punished and tormented forever.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Geloscopy:")]), _vm._v(" Divination by observing a person’s manner of laughing.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gelug:")]), _vm._v(" The reformed sect of Lamaism (Tibetan Buddhism); called the Yellow Sect. Its head and representative, the Dalai Lama, has temporal rule over Tibet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gemarah:")]), _vm._v(" Hebrew for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("completion;")]), _vm._v(" the name of the larger and latter part of the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Talmud")]), _vm._v(" (q.v.) discussing the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Mishnah")]), _vm._v(" (q.v.) and incorporating also vast materials not closely related to the Mishnah topics. The 1812 authorities of the Gemarah are known as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Amoraim")]), _vm._v(" (speakers). Its contents bears on "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hadaeha")]), _vm._v(" (law) and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Aggadah")]), _vm._v(" (tale), i.e., non-legal material like legends, history, science, ethics, philosophy, biography, etc. There are two Gemarahs better known as Talmuds: the Jerusalem (i.e., Palestinian) Talmud and the Babylonian Talmud.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gemini")]), _vm._v(" (The Twins): The third sign of the Zodiac. Its symbol (II) represents two pieces of wood bound together, symbolical of the unremitting conflict of contradictory mental processes. The Sun is in Gemini annually from May 21 to June 20. Astrologically it is the thirty degree arc immediately preceding the Summer Solstice, marked by the passing of the Sun over the Tropic of Cancer, and occupying a position along the Ecliptic from 60° to 90°. It is the “mutable” quality of the element Air: positive, dual. Ruler: Mercury. Detriment: Jupiter. Symbolic interpretation: Castor and Pollux; Bohas and Jakin, of Solomon’s Temple; the Pillars of Hercules.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gemini era:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cosmic epochs.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Genethliacal astrology:")]), _vm._v(" Natal astrology—which deals with the geniture in a nativity (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Genethlialogy:")]), _vm._v(" That department of astrology which deals with the birth of individuals, so as to form a judgment of the characteristics of a person from a map of the heavens cast for his given birth moment.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Genie:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Jinn.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Geniture:")]), _vm._v(" An astrological term, approximately synonymous with Nativity, as referring to the subject whose birth horoscope is under consideration. (A reasonable discrimination would be to use the term Nativity in reference to the person, and the term Geniture in reference to the configurations which show in his birth map.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Genius:")]), _vm._v(" In occult terminology, a nature-spirit; the personification of the indwelling dynamic force which activates an object or phenomenon, gives it energy and determines its effectual and organic existence. Also, a spirit, especially in classical literature, which accompanies a person throughout his entire earthly life as a protective (beneficent genius) or destructive (evil genius) force. (Plural: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("genii")]), _vm._v(".) The word is frequently, but improperly, used also as a synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Jinn")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Geomancy:")]), _vm._v(" Divination by the shapes resulting from throwing a handful of soil on a flat surface.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Geomancy, astrological:")]), _vm._v(" A system of divination, employing a map containing twelve divisions, in which are placed symbols of geomancy, in conjunction with the ruling planets and signs.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Geoarc:")]), _vm._v(" A term applied by some modern astrologers to one of the house divisions of a map erected for a given moment, when considering the effect upon an individual, at a given point on the Earth’s periphery, of his motion around the Earth’s center—in the Earth’s daily rotation. The same subdivision of the same map is called a "), _c('em', {
    staticClass: "i"
  }, [_vm._v("heliarc,")]), _vm._v(" when considering effects based on the actual motions in orbit around the Sun, of all the planets—including the Earth. In other words, Geoarc is synonymous with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("House,")]), _vm._v(" and Heliarc with "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Solar House,")]), _vm._v(" emphasizing the character of the motion to which the subdivisions apply.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gharb")]), _vm._v(" i "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("mutlaq:")]), _vm._v(" Arabic for the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("absolute void;")]), _vm._v(" in Sufism, the plane of absolute inactual being.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghebers:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Gabars.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghost:")]), _vm._v(" In mediumistic terminology, a deceased person or the image of a deceased person appearing to the living. Identified by occultists with the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("astral shell")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("etheric double")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghost cult:")]), _vm._v(" The practices and ritual observances, associated with the propitiation or avoidance of the ghosts of the dead.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghost-seer:")]), _vm._v(" A person able to see discarnate spirits. In the folklore of most nations, persons born on certain days or at certain times of the day are credited with this faculty.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghostway ceremonials:")]), _vm._v(" Magic rites of the Navajo Indians.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ghoul:")]), _vm._v(" A demon which feeds on dead bodies of human beings.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Ginnunga gap:")]), _vm._v(" The primeval chaos from which, according to old Norse mythology, all things issued. (The term has been variously translated as "), _c('em', {
    staticClass: "i"
  }, [_vm._v("yawning gap, gaping void,")]), _vm._v(" etc.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Girru:")]), _vm._v(" The Babylonian god of fire.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gligua:")]), _vm._v(" Medicine-man or witch-doctor of Chilean Indians.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Glassolalia:")]), _vm._v(" The speaking in unknown or non-existent tongues. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Xenoglossis.")]), _vm._v(")")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Glottologue:")]), _vm._v(" A medium who speaks in unknown tongues. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Xenoglossis")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gnana, etc.")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Jnana,")]), _vm._v(" etc.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gnome:")]), _vm._v(" An "), _c('em', {
    staticClass: "i"
  }, [_vm._v("elemental")]), _vm._v(" (q.v.) of the element Earth.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gnosiology:")]), _vm._v(" Theory of knowledge in so far as it relates to the origin, nature, limits and validity of knowledge as distinguished from methodology, the study of the basic concepts, postulates and presuppositions of the special sciences.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gnosis:")]), _vm._v(" Greek for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Knowledge.")]), _vm._v(" Originally, a generic term for knowledge, in the first and second centuries A.D. it came to mean an esoteric knowledge of higher religious and philosophic truths to be acquired by an elite group of intellectually developed believers. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Gnosticism")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gnosticism:")]), _vm._v(" A creed representing a mixture of the doctrines of the Babylonian, Egyptian, Indian and Christian religions, occultism, astrology and magic, as well as parts of the Hebrew Kabalistic teachings. Its origin is still a matter of debate. According to the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Encyclopedia of Religion")]), _vm._v(" by V. Ferm, “Gnosticism is now regarded as pre-Christian Oriental mysticism.” All Gnostic sects had their priests who practiced astrology and the magic arts, and it is claimed that the Gnostics continued to celebrate the ancient Greek mysteries, too. The Church regarded the Gnostics as heretics and sorcerers and persecuted them as such.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Goat:")]), _vm._v(" The form in which the devil was supposed to presidf over the Witches’ Sabbath. (See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Bachelor; Baphomet.")]), _vm._v(") (For the astrological significance of the word, see "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Capricorn")]), _vm._v(".)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Goblin:")]), _vm._v(" A mischievous nature-spirit.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Godhead:")]), _vm._v(" In general, the state of being a god, godhood, godness, divinity, deity. More strictly, the essential nature of God, especially the triune God, the One in Three.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Goëtic magic:")]), _vm._v(" Black magic, sorcery.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gog and Magog:")]), _vm._v(" In Hebrew occultism, the rebel people who rise up against God and His anointed.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Golden age:")]), _vm._v(" In occultism, the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Satya Yuga")]), _vm._v(" (q.v.); an era of purity, simplicity of interests and pursuits and universal happiness.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Golden chain:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hermetic chain.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Golem:")]), _vm._v(" In Jewish mystic lore, an android or homunculus (q.v.) made by the great medieval mystic Rabbi Loew of Prague, who wrote the ineffable name of God on a piece of parchment which he placed in the android’s mouth; the magic name gave the Golem life and it was alive until the parchment was removed, when it again became an empty, lifeless hulk.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gomerah:")]), _vm._v(" The medicine-man or shamanistic medium of certain tribes of Australian aborigines.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Good Wisdom, Stage of:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Dasa-bhumi.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gorgons:")]), _vm._v(" In Greek mythology, three hideous sisters, with serpent-entwined hair and glaring eyes that turned to stone anything that met their gaze.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Grail:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Holy Grail.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Grand trine:")]), _vm._v(" In astrology, two planets trine (q.v.) to each other, both of which are trined by a third planet.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Graphology:")]), _vm._v(" The study of the relations between a person’s handwriting and his character.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greal:")]), _vm._v(" In the myths of the early inhabitants of the British Isles, a magic drink, supposed to give inspiration and enlightenment, prepared by the fertility goddess Ceridwen from the juices of six plants.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great change:")]), _vm._v(" Since all occult philosophies believe in survival after the death of the physical body, and hence according to them there is really no death, physical death is usually referred to as the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("great change")]), _vm._v(" or the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("transition.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great Circle of Necessity:")]), _vm._v(" The Orphic term for the Wheel of Life, the alternations of life and death, of imprisonment in a physical body and freedom.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great Initiate:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Elder Brother.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great terrestrial crucible:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Astral light.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great White Brotherhood:")]), _vm._v(" In general occult terminology, a synonym for Great White Lodge (q.v.). In the terminology of the Rosicrucians, the Great White Brotherhood is “the school or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Fraternity")]), _vm._v(" of the Great White Lodge and into this invisible Brotherhood of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("visible")]), _vm._v(" members every true student of the Path prepares for admission.” (Rosicrucian Manual)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Great White Lodge:")]), _vm._v(" The Hierarchy of Adepts or Elder Brothers which, according to occultistic teachings, is the true, inner government of the world.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Greater mysteries:")]), _vm._v(" The "), _c('em', {
    staticClass: "i"
  }, [_vm._v("solar mysteries")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Green Lion, Hunting of the:")]), _vm._v(" A medieval alchemical treatise on the search for the Philosopher’s Stone (q.v.). The Green Lion is natural, unpurified, undeified Man—green because he is unripe, his occult powers are dormant, but having the strength and fierceness of a lion.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Grhya-sutras:")]), _vm._v(" The “House Books” of Hinduism, teaching and expounding the rites for the critical points of life, from birth to death, and the family sacrifices.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Grimoire:")]), _vm._v(" A name applied to any book on black magic which pretends to teach the practice of black magic, especially the art of the evocation of evil spirits and making an alliance with them.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gross body:")]), _vm._v(" In occult terminology, the physical body.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Group soul:")]), _vm._v(" The philosophical concept, introduced by F. W. H. Myers, of a number of souls bound together by one spirit, acting and reacting upon each other in the ascending scale of psychic evolution.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Group spirit:")]), _vm._v(" See: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Group soul.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gruagach:")]), _vm._v(" A benevolent but mischievous fairy of Scottish folklore.")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Guardian angel:")]), _vm._v(" Synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("guide")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Guide:")]), _vm._v(" While this term is frequently used in spiritualism and occultism in general as a synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("control")]), _vm._v(" (q.v.), properly used it means a continual, benevolent, protective supermundane influence. ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("Control")]), _vm._v(" may be any communicator who happens to make contact with a medium.)")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Guiding spirit:")]), _vm._v(" Synonym for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("guide")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Guna:")]), _vm._v(" A Sanskrit term denoting a quality or basic attribute of the Cosmic Substance ("), _c('em', {
    staticClass: "i"
  }, [_vm._v("prakriti")]), _vm._v("). The three "), _c('em', {
    staticClass: "i"
  }, [_vm._v("gunas")]), _vm._v(" of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("prakriti")]), _vm._v(" are: "), _c('em', {
    staticClass: "i"
  }, [_vm._v("sattva, rajas")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("tamas")]), _vm._v(" (q.v.).")]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gupta Vidya:")]), _vm._v(" Sanskrit for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("esoteric knowledge.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Guru:")]), _vm._v(" The Sanskrit term for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("spiritual leader")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("teacher.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Gyromancy:")]), _vm._v(" Divination by having a person walk around a chalked circle until he collapses and observing the position of his body relative to the circle.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eeb31a32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/e9780806537009_c07.vue
// module id = 93
// module chunks = 0